import React from "react";
import { Card, Heading3, P, WarningNotification } from "@ovotech/element";

export function HoldingBanner() {
  return (
    <Card>
      <Heading3>Our plans & prices</Heading3>
      <WarningNotification id="error-banner" title="">
        <P>
          While we&apos;re improving your online experience you won&apos;t be
          able to view plans at the moment.
        </P>
      </WarningNotification>
    </Card>
  );
}
